const styles = () => ({
  insideTabContainer: {
    flex: 1,
    minHeight: 0,
    display: "flex",
    flexDirection: "column" as const,
    borderRadius: 0,
    boxShadow: "none",
  },
  root: {
    width: "100%",
    flex: 1,
    boxSizing: "border-box" as const,
  },
});

export default styles;
